import { render, staticRenderFns } from "./UsersAddEditPage.vue?vue&type=template&id=52a44c14&scoped=true&"
import script from "./UsersAddEditPage.vue?vue&type=script&lang=js&"
export * from "./UsersAddEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a44c14",
  null
  
)

export default component.exports